import * as React from "react";
import "../App.css";

import Map from "../components/MapJS.js";

const Parkview = ({version}) => {
console.log(version)

  return (
      <Map version={version} />
  );
};
export default Parkview;
